var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-wrapper mt-2 mb-2 ml-2 mr-2"},[_c('div',{staticClass:"spinner"},[_c('b-spinner',{attrs:{"variant":"primary"}})],1),(_vm.msg != '')?_c('p',[_vm._v(" "+_vm._s(_vm.msg)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }